import { render, staticRenderFns } from "./documentos-adjuntos-detalle.vue?vue&type=template&id=c6859304&"
import script from "./documentos-adjuntos-detalle.vue?vue&type=script&lang=js&"
export * from "./documentos-adjuntos-detalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports